module.exports = __webpack_public_path__ + "static/image25-9771afa16409876d6d79f08268bd9c5f.png";